import { Component, computed, Input, OnInit, inject } from '@angular/core';
import { PersonCurrentMedicationStore } from './person-current-medication.store';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { FolderMedicationGridItemObject } from '@it2go/types';
import {
    FolderMedicationUpsertDialogComponent,
} from '../../../../../components/medical-service/folder/folder-medications/folder-medication-upsert-dialog/folder-medication-upsert-dialog.component';
import { globalStore, translate } from '../../../../shared/shared.global-service';
import { selectCurrentService } from '../../../store/person/person.selectors';
import { BaseDialogService } from '../../../../../components/kit/base-dialog/base-dialog-service';

import { LinkButtonComponent } from '../../../../../components/kit/button/link-button.component';
import { FormatDosingPipe } from '../../../pages/person/folder-medications-page/folder-medications.pipe';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { ButtonComponent } from '../../../../../components/kit/button/button.component';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import { MedicationInfoComponent } from '../../../../shared/components/kit/medication-info/medication-info.component';
import { CountDaysDiffPipe } from '../../../../shared/pipes/count-days-diff.pipe';
import { FormatDaysDiffPipe } from '../../../../shared/pipes/format-days-diff.pipe';
import { PrimeTemplate } from '@openng/optimus-ui/api';

@Component({
    selector: 'app-person-current-medication',
    templateUrl: 'person-current-medication.component.html',
    styleUrls: ['person-current-medication.component.scss'],
    providers: [PersonCurrentMedicationStore],
    imports: [
    LinkButtonComponent,
    TranslatePipe,
    FormatDosingPipe,
    Tooltip,
    ButtonComponent,
    TableComponent,
    MedicationInfoComponent,
    CountDaysDiffPipe,
    FormatDaysDiffPipe,
    PrimeTemplate
],
})
export class PersonCurrentMedicationComponent implements OnInit {
    protected readonly store = inject(PersonCurrentMedicationStore);
    protected readonly translateService = inject(TranslateService);
    protected readonly dialogService = inject(BaseDialogService);

    @Input() folderId!: number;

    protected columns = computed(() => [
        ...(this.store.isAllowed('folder.update')() ? [{ name: 'icon' }] : []),
        { name: 'medicine' },
        { name: 'dosing' },
        { name: 'stock' },
    ]);

    constructor() {
        const store = this.store;
        store.onSuccess(
            () => this.loadFolderMedications(),
            'updateFolderMedication',
        );
    }

    ngOnInit(): void {
        this.loadFolderMedications();
    }

    showUpdateMedicationDialog(medication: FolderMedicationGridItemObject) {
        this.dialogService.open(FolderMedicationUpsertDialogComponent, {
            header: translate.instant('folderMedication.upsertDialog.titleUpdate'),
            styleClass: 'p-dialog-width-70',
            data: {
                folderId: this.folderId,
                personId: medication.folder?.person?.id || 0,
                folderMedicationId: medication?.id,
                service: globalStore!.selectSignal(selectCurrentService)(),
            },
        });
    }

    private loadFolderMedications() {
        this.store.api.getFolderMedications({
            filter: [
                [
                    { column: 'to', operator: 'GTE', value: [new Date().toISOString()] },
                    { column: 'to', operator: 'EMPTY', value: ['0'] },
                ],
                [
                    { column: 'packageTo', operator: 'GTE', value: [new Date().toISOString()] },
                    { column: 'packageTo', operator: 'EMPTY', value: ['0'] },
                ],
            ],
            additionalFilter: [
                [{ column: 'folderId', operator: 'EQ', value: [this.folderId.toString()] }],
                [{ column: 'active', operator: 'EQ', value: ['true'] }],
            ],
        }).then();
    }
}
